export default __webpack_public_path__ + "static/core1r-f55f762ff1c6402668f5b3c74b7d2f5f.jpg";